<template>
    <div class="product-delivery">
        <div class="product-delivery-header">
            <div>
                <h4 class="product-info-content-title">
                    <svg class="d-none" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" enable-background="new 0 0 64 64" xml:space="preserve">
                        <path fill="#101316" d="M6.414,27.458c0-0.556,0.453-1.009,1.009-1.009h22.488c0.556,0,1.008,0.454,1.008,1.009 c0,0.557-0.452,1.009-1.008,1.009H7.423C6.867,28.467,6.414,28.015,6.414,27.458z M62.035,36.015v7.254 c0,1.005-0.817,1.823-1.821,1.823h-1.507c-0.483,2.801-2.91,4.869-5.793,4.869c-2.871,0-5.306-2.072-5.791-4.869H26.264 c-0.486,2.789-2.937,4.865-5.789,4.865c-2.847,0-5.295-2.072-5.786-4.855h-3.932c-0.551,0-1-0.449-1-1v-4.995H2.994 c-0.556,0-1.009-0.452-1.009-1.009c0-0.556,0.453-1.009,1.009-1.009H25.48c0.557,0,1.009,0.453,1.009,1.009 c0,0.557-0.453,1.009-1.009,1.009H11.757v3.962h4.988l-0.055,0.3c-0.046,0.243-0.069,0.482-0.069,0.71 c0,2.127,1.729,3.856,3.854,3.856c2.124,0,3.852-1.728,3.854-3.86c0-0.226-0.023-0.463-0.068-0.706l-0.056-0.3h22.917 c0.484-2.798,2.919-4.869,5.791-4.869c2.884,0,5.311,2.068,5.793,4.869h1.306c0,0-0.002-7.151-0.006-7.201h-1.72 c-0.558,0-1.012-0.453-1.012-1.01c0-0.559,0.454-1.013,1.012-1.013h0.603l-0.999-1.222H45.102c-1.452,0-2.634-1.18-2.634-2.632 v-6.487c0-1.453,1.182-2.633,2.634-2.633h3.172l-1.656-2.025c-0.426-0.52-1.056-0.818-1.728-0.818H12.408 c-0.556,0-1.009-0.454-1.009-1.014c0-0.556,0.453-1.009,1.009-1.009H44.89c1.281,0,2.482,0.568,3.293,1.561l12.892,15.754 C61.693,34.078,62.035,35.035,62.035,36.015z M44.49,29.991c0,0.337,0.274,0.611,0.611,0.611h11.134l-6.308-7.709h-4.826 c-0.337,0-0.611,0.275-0.611,0.611V29.991z M52.914,40.199c-2.139,0-3.88,1.74-3.88,3.881c0,2.139,1.741,3.881,3.88,3.881 c2.141,0,3.881-1.742,3.881-3.881C56.795,41.939,55.055,40.199,52.914,40.199z"></path>
                    </svg>
                    Доставка
                </h4>
                <div class="product-delivery-locations">
                    <span class="product-delivery-city" @click.prevent="$parent.selectCity">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                             x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" enable-background="new 0 0 64 64"
                             xml:space="preserve">
                            <path fill="" d="M31.999,9.806c9.128,0,16.554,7.428,16.554,16.56c0,13.604-14.906,26.887-15.539,27.446 c-0.289,0.257-0.651,0.383-1.015,0.383c-0.36,0-0.723-0.126-1.011-0.383c-0.636-0.559-15.541-13.842-15.541-27.446 C15.447,17.234,22.874,9.806,31.999,9.806 M31.999,7.806c-10.229,0-18.552,8.326-18.552,18.56 c0,14.529,15.559,28.367,16.221,28.948c0.633,0.564,1.465,0.881,2.331,0.881c0.867,0,1.699-0.315,2.343-0.888 c1.655-1.461,16.211-14.72,16.211-28.941C50.553,16.132,42.229,7.806,31.999,7.806L31.999,7.806z"></path>
                            <path fill="" d="M31.999,21.784c2.523,0,4.568,2.044,4.568,4.568c0,2.521-2.045,4.567-4.568,4.567 c-2.521,0-4.566-2.046-4.566-4.567C27.433,23.829,29.478,21.784,31.999,21.784 M31.999,19.784c-3.621,0-6.566,2.946-6.566,6.568 c0,3.621,2.946,6.567,6.566,6.567c3.622,0,6.568-2.946,6.568-6.567C38.567,22.73,35.621,19.784,31.999,19.784L31.999,19.784z"></path>
                        </svg>
                        <span v-text="$parent.cityName"></span>
                    </span>
                    <a v-if="hasPickupPoints"
                       class="product-delivery-pickup-point"
                       @click.prevent="$parent.showPickupPoints()">{{ pickupPointsCountLabel(true) }}</a>
                </div>
            </div>
        </div>
        <div class="product-delivery-type" v-if="this.deliveryOption" >
            <div v-for="delivery in deliveries" class="product-delivery-type-item">
                <div class="cpdti-title">
                    <span>{{ deliveryLabel(delivery) }}</span>
                    <span v-html="deliveryCost(delivery)"></span>
                </div>
                <span class="cpdti-date">
                    {{ deliveryDays(delivery) }},
                    {{ fittingAvailable(delivery) ? ' примерка' : ' без примерки' }}{{ partialPayments(delivery) ? ', частичный выкуп' : '' }}

                </span>
            </div>
            <div class="product-delivery-type-item">
                <div class="free">
                    <span>Бесплатно</span>
                    - при онлайн оплате и заказе свыше 5000 руб.
                </div>
            </div>
        </div>
        <div>
            <a href="/delivery/" class="link mt-3">Подробнее о доставке </a>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'ProductDelivery',
        props: {
            productId: {
                type: Number,
                required: true
            }
        },
        data () {
            return {
                deliveryOption: true,
            };
        },
        mounted () {
            let _this = this;

            _this.$store.commit('geo/loadDeliveryDataOnCityChange');
        },
        methods: {
            deliveryCost (delivery) {
                let payment = delivery.payments.find(item => item.payment_type_id === 1);

                if (payment) {
                    if (payment.cost) {
                        return this.$root.priceFormat(payment.cost) + ' &#8381;';
                    } else {
                        return 'Бесплатно';
                    }
                }

                return '';
            },
            fittingAvailable (delivery) {
                return delivery.payments.filter(item =>
                    item.payment_type_id === 1
                    && item.try_on === 1
                ).length;
            },
            deliveryDays (delivery) {
                return delivery.min_delivery_time + '-' + delivery.max_delivery_time + (delivery.max_delivery_time > 4 ? ' дней' : ' дня');
            },
            deliveryLabel (delivery) {
                let method = this.deliveryMethodName(delivery.delivery_method_id);
                let service = this.deliveryServiceName(delivery.delivery_service_id);

                if (service.includes(method)) {
                    return service;
                }
                return method + ' ' + service;
            },
            partialPayments(delivery) {
                return [1,2].indexOf(delivery.delivery_method_id) !== -1;
            },
            toggleDelivery() {
                this.deliveryOption = !this.deliveryOption
            }

        },
        computed: {
            ...mapGetters('asset', [
                'deliveryMethodName',
                'deliveryServiceName',
            ]),
            ...mapGetters('delivery', [
                'hasPickupPoints',
                'locationDeliveries',
                'deliveryMethodHasPickupPoints',
                'servicePickupPoints',
                'pickupPointsCountLabel'
            ]),
            deliveries () {
                let _this = this;

                return _this.$store.state.geo.location.region
                    ? _this.locationDeliveries(_this.$store.state.geo.location.region.id, _this.$store.state.geo.location.city.id)
                    : [];
            }
        }
    }
</script>
